module.exports = __webpack_public_path__ + "img/erp-logos_0036_commerce7.7718daf4.jpg";